import { FaPhp, FaLaravel, FaJs, FaLinux, FaDatabase, FaAws, FaPython, FaDocker } from 'react-icons/fa';
import { FaGolang } from "react-icons/fa6";
import { SiMongodb, SiMysql, SiPostgresql, SiDigitalocean, SiHtml5, SiCss3, SiAngular, SiVuedotjs, SiReact, SiNodedotjs, SiTailwindcss } from 'react-icons/si';

export const iconsMap = {
    PHP: <FaPhp />,
    Laravel: <FaLaravel />,
    Javascript: <FaJs />,
    Linux: <FaLinux />,
    MySQL: <SiMysql />,
    PostgreSQL: <SiPostgresql />,
    MongoDB: <SiMongodb />,
    SQLite: <FaDatabase />,
    AWS: <FaAws />,
    DigitalOcean: <SiDigitalocean />,
    HTML: <SiHtml5 />,
    CSS: <SiCss3 />,
    Angular: <SiAngular />,
    'Vue.js': <SiVuedotjs />,
    'React.js': <SiReact />,
    TailwindCSS: <SiTailwindcss />,
    Python: <FaPython />,
    Golang: <FaGolang />,
    NodeJs: <SiNodedotjs />,
    Docker: <FaDocker />
};